import React, { useState, useContext } from 'react';
import { ThemeContext } from '../context/theme-context';
import styles from '../styles/Footer.module.css';
import {
    FaEnvelope,
    FaPhone,
    FaGithub,
    FaLinkedin,
    FaTwitter,
    FaPaperPlane, FaSkype, FaWhatsapp, FaGoogle
} from 'react-icons/fa';

function Footer() {
    const { theme } = useContext(ThemeContext);
    const [email, setEmail] = useState('');

    const navItems = [
        { name: 'Home', href: '#about' },
        { name: 'Skills', href: '#skills' },
        { name: 'Experience', href: '#experience' },
        { name: 'Projects', href: '#projects' },
        { name: 'Testimonials', href: '#testimonials' },
        { name: 'Contact', href: '#contact' }
    ];

    const socialLinks = [
        {
            icon: <FaLinkedin />,
            href: 'https://be.linkedin.com/in/leeroy-msizi-kamafu-5a01a899',
            label: 'LinkedIn'
        },
        {
            icon: <FaSkype />,
            href: 'https://teams.microsoft.com/l/chat/0/0?users=leeroy.ncube4',
            label: 'Skype'
        },
        {
            icon: <FaWhatsapp />,
            href: 'https://wa.me/+32498060528',
            label: 'WhatsApp'
        },
        {
            icon: <FaGoogle />,
            href: 'mailto:ncubelee04@gmail.com',
            label: 'GMail'
        }
    ];

    const handleNewsletterSubmit = (e) => {
        e.preventDefault();
        // Implement newsletter signup logic
        console.log('Newsletter signup:', email);
        setEmail('');
    };

    return (
        <footer
            className={styles.footer}
            data-theme={theme}
        >
            <div className="container">
                <div className={styles.footerContent}>
                    <a href="#home" className={styles.footerLogo}>
                        L.M.N
                    </a>

                    <nav className={styles.footerNavigation}>
                        {navItems.map((item, index) => (
                            <a
                                key={index}
                                href={item.href}
                                className={styles.footerNavItem}
                            >
                                {item.name}
                            </a>
                        ))}
                    </nav>

                    <div className={styles.socialLinks}>
                        {socialLinks.map((link, index) => (
                            <a
                                key={index}
                                href={link.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.socialLink}
                                aria-label={link.label}
                            >
                                {link.icon}
                            </a>
                        ))}
                    </div>

                    <div className={styles.contactInfo}>
                        <div className={styles.contactItem}>
                            <FaEnvelope className={styles.contactIcon} />
                            <span>ncubelee04@gmail.com</span>
                        </div>
                        <div className={styles.contactItem}>
                            <FaPhone className={styles.contactIcon} />
                            <span>+32 498 06 05 28</span>
                        </div>
                    </div>

                    <div className={styles.divider}></div>

                    <div className={styles.newsletterSection}>
                        <form
                            className={styles.newsletterForm}
                            onSubmit={handleNewsletterSubmit}
                        >
                            <input
                                type="email"
                                placeholder="Subscribe to my newsletter"
                                className={styles.newsletterInput}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <button
                                type="submit"
                                className={styles.newsletterButton}
                            >
                                <FaPaperPlane /> Subscribe
                            </button>
                        </form>
                    </div>

                    <div className={styles.copyrightNotice}>
                        © {new Date().getFullYear()} <a href="https://intellommerce.ai"><strong>Intellommerce</strong></a>.
                        All Rights Reserved.
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;